
import { Grid2, Typography, TextField, Button, IconButton } from "@mui/material"
import styles from "./Login.module.css"
import logo from "../assets/svg/logo2.png"
import tradebossLogo from "../assets/svg/wealthvaultlogo.svg"
import edit from "../assets/svg/edit.svg"
import { useState } from "react"
import AppConfig from "../utilities/appConfig"
import ApiClient from "../utilities/apiClient"
import { ThreeDots } from "react-loader-spinner";
import CryptoJS from "crypto-js";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { MuiOtpInput } from "mui-one-time-password-input";

import { useNavigate } from "react-router-dom"


export default function Login({setAccounts, setAmount, setUser, setUserBanks , setInvestAmount}) {

    const [mobile, setMobile] = useState("")
    const [error, setError] = useState(false)
    const [errorMsg,setErrorMsg] = useState("")
    // const [state, setState] = useState("")
    const [screen, setScreen] = useState("login")
    const [otp, setOtp] = useState("")
    const [genOtp, setGenOtp] = useState(false)

    const theme = createTheme({
        components: {
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: "28px", // Rounded border
                        border: "1px solid transparent", // Removes any extra border
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "transparent", // No border on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "transparent", // No border when focused
                        },
                    },
                    notchedOutline: {
                        border: "none", // Removes the default Material-UI border
                    },
                    input: {
                        fontSize: "16px", // Input and placeholder font size
                        textAlign: "center", // Center alignment
                        letterSpacing: "2px", // Letter spacing
                    },
                },
            },
        },
    });

    const handleLogin = () => {
        setGenOtp(true)
        setError(false)
        setErrorMsg("")
        localStorage.clear()
        if (mobile.length < 10) {
            setError(true)
            setGenOtp(false)
            console.log("length")
            return setErrorMsg("Mobile no. should be 10 digits")
        }
        const apiClient = new ApiClient()
        apiClient.fetchData(AppConfig.api.Login.genOtp, "POST", {
            mobileno:mobile
        }).then((response)=>{
            if (response?.Success == "true"){
                setGenOtp(false)
                localStorage.setItem("mobile", mobile)
                setScreen("otp")
                setError(false)
            }
            if(response?.Success == "false") {
                setGenOtp(false)
                if (response["Success Description"].includes("Registration incomplete")) {
                    setErrorMsg(
                        <>
                            Registration incomplete. Click{" "}
                            <a href="https://kyc.tradeboss.co/" target="_blank" rel="noopener noreferrer"
                                style={{

                                    color: "#210058",
                                    fontFamily: "Inter400"
                                }}>
                                SignUp
                            </a>
                            {" "}To Proceed
                        </>
                    );
                }
                setError(true)
            }
        }).catch(e=>{
            setGenOtp(false)
            console.log(e,"e")
        })
    }

    const handleOTPChange = (newValue) => {
        setOtp(newValue)
    }

    const vaildateOTP = () =>{
        setGenOtp(true)
        const apiClient = new ApiClient()
        apiClient.fetchData(AppConfig.api.Login.verifyOtp, "POST", {
            mobileno:mobile,
            otp:otp
        }).then((response)=>{
            if (response["Success Description"] == "Invalid otp" || response["Success Description"] == "otp expired") {
                setGenOtp(false)
                setError(true)
                setErrorMsg(response["Success Description"])
            }
            if(response?.Success == "true"){
                console.log(response.data , "useDetails")
                localStorage.setItem("token" ,response?.token)
                setInvestAmount({energetic : response?.energitic , traditional : response?.traditional})
                setAccounts(response?.data)
                localStorage.setItem('accounts',JSON.stringify(response?.data))
                setAmount(response?.subscription_fee)
                const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(response),process.env.REACT_APP_SECRET_KEY).toString()
                localStorage.setItem('data',encryptedData)
                setInvestAmount({
                    energetic : response?.traditional ,
                    traditional : response?.energitic
                })

                if(response?.data?.length === 1 &&  response?.data[0]?.subscription == "true"){
                    localStorage.setItem("account" ,JSON.stringify(response?.data[0]))
                    setUser(response?.data[0])
                    return navigate("/dashboard")
                }

                navigate('/accounts')
            }
        }).catch(e=>{
            console.log(e, "the errror")
            setError(false)
        })
    }




    const navigate = useNavigate()

    return (
        <div className={styles.logincontainer}  >

            {/* <img src={background} className={styles.logincontainer} width="2000px" />  */}
            <Grid2 className={styles.login} >
                <img src={tradebossLogo} alt={logo} className={styles.inner_logo} />
                {screen == "login" && <>
                    <Typography className={styles.logintext}>Login</Typography>
                    <Typography className={styles.logintext1}>Login with phone number</Typography>
                    <ThemeProvider theme={theme}>
                    <TextField
                    className={styles.textField}
                    value={mobile}
                    error={error ? true : false}
                    onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10)
                    }}
                    onClick={() => setError(false)}
                    onChange={(e) => setMobile(e.target.value)}
                    type='number'   
                    inputProps={{
                        maxLength: 10,
                        style: { 
                            letterSpacing: mobile.trim().length > 0 && "10px",
                        }
                    }} placeholder='+91 - 0 0 0 0 0 0 0 0 0 0' 
                     />
                    </ThemeProvider>
                                    
                                    
                    {error && <Typography sx={{ fontSize: "14px", color: "#EC0707", mt: "10px", textAlign: "center", padding: "0px 20px" }}>{errorMsg}</Typography>}
                <Button className={styles.loginbutton} onClick={handleLogin}>
                {!genOtp ? "Login" : <ThreeDots
                                        visible={true}
                                        height="50"
                                        width="50"
                                        color="#000000"
                                        radius="9"
                                        ariaLabel="three-dots-loading"  
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />}
                            </Button>
                </>}
                {screen == "otp" && <>
                    <Typography className={styles.logintext}>OTP</Typography>
                    <Typography className={styles.logintext2} sx={{ mt: "10px" }}>Enter OTP sent to +91-{localStorage.getItem("mobile")}

                        <IconButton onClick={() => {
                                setScreen("login")
                            }}>
                            <img  src={edit} alt={edit} />
                        </IconButton>

                    </Typography>
                    <Grid2 display="flex" justifyContent="center">
                        <ThemeProvider theme={theme}>
                    <MuiOtpInput
                        autoFocus
                        sx={{
                            width: "100%",
                            marginTop: "20px",
                            "& .MuiOutlinedInput-input": {
                                fontSize: "54px",
                                color: "#999999",
                                background: "#FFFFFF",
                                width: "50px",
                                height: "50px",
                                borderRadius: "6px",
                                ".css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
                                    borderRadius: "6px"
                                }
                            },
                            "@media only screen and (max-width: 480px)":{
                                width: "270px",
                                "& .MuiOutlinedInput-input": {
                                fontSize: "24px",
                                color: "#999999",
                                background: "#FFFFFF",
                                width: "40px",
                                height: "20px",
                                borderRadius: "6px",
                                ".css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
                                    borderRadius: "16px",
                                }
                            },
                            },
                            "@media only screen and (max-height:639px)": {
                                "& .MuiOutlinedInput-input": {
                                    width: "40px",
                                    height: "30px",
                                    fontSize: "24px"
                                }
                            }
                        }}
                        value={otp}
                        onChange={handleOTPChange}
                    />
                        </ThemeProvider>
                    </Grid2>
                    {genOtp && <ThreeDots
                                visible={true}
                                height="40"
                                width="40"
                                color="#F3D45E"
                                radius="9"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />}
                    {error && !genOtp && <Typography sx={{ fontSize: "14px", color: "#EC0707", mt: "15px" }}>{errorMsg}</Typography>}
                    <Button disabled={otp.length !== 4} className={styles.otpbutton} sx={{
                        // width : "375px !important",
                        backgroundColor: otp.length !== 4 ? 'rgba(244, 188, 46, 0.6) !important' :'#F3D45E !important'
                        , marginTop: error || genOtp ? "20px" :"30px"}} onClick={vaildateOTP}>Proceed</Button>
                </>}  
            </Grid2>
        </div>
    )
}